<template>
  <div>
    <v-row class="justify-center my-4">
      <h3 class="primary--text">Novo Usuário</h3>
    </v-row>
    <v-row class="justify-center mb-4">
      <v-col cols="10" sm="6">
        <v-form ref="form" v-model="formValid">
          <v-row class="justify-center">
            <v-text-field
              v-model="email"
              :rules="ruleEmail"
              label="Email"
              @input="validateField('email')"
            ></v-text-field>
          </v-row>
          <v-row class="justify-center">
            <v-text-field
              type="password"
              v-model="pass"
              :rules="rulePass"
              maxlength="8"
              label="Senha"
              @input="validateField('pass')"
            ></v-text-field>
          </v-row>
          <v-row class="justify-center">
            <v-text-field
              type="password"
              v-model="verif"
              :rules="matchPass"
              :append-icon="appendIco"
              maxlength="8"
              label="Confirme senha"
              @input="validateField('verif')"
            ></v-text-field>
          </v-row>
          <v-row class="justify-center">
            <v-btn
              :disabled="disabled"
              :loading="loading"
              outlined
              color="primary"
              @click="registrar()"
              >registrar</v-btn
            >
          </v-row>
        </v-form>
      </v-col>
    </v-row>

    <v-snackbar v-model="alert" multi-line color="accent" :timeout="2000">
      {{ msg }}
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="alert = false">
          X
        </v-btn>
      </template>
    </v-snackbar>

  </div>
</template>

<script>
export default {
  name: "new-user",
  computed: {
    error() {
      return this.$store.getters.error;
    },
    logado() {
      return this.$store.getters.logado;
    }
  },
  watch: {
    logado(i) {
      if (i) {
        if (i.cancel) {
          if (this.$route.path !== "/login") {
            this.$router.push("/login");
          }
        } else {
          this.$router.push("/cadastro");
        }
      }
    },
    error(e) {
      if (e === "auth/email-already-in-use"){
        this.msg = "Usuário já cadastrado. Consulte o Administrador.";
        this.alert = true;
        setTimeout(() => {
          if (this.$route.path !== "/login") {
            this.$router.push("/login");
          }
        }, 3000);
      }
    }
  },
  data() {
    return {
      alert: false,
      msg: "",
      appendIco: "",
      disabled: true,
      loading: false,
      formValid: false,
      email: '',
      pass: '',
      verif: '',
      rulePass: [ value => !!value || 'Obrigatório.', value => value.length >= 6 || 'Mín. 6 caracteres' ],
      matchPass: [ value => !!value || 'Obrigatório.', value => value === this.pass || 'As senhas não coincidem' ],
      ruleEmail: [
          value => !!value || 'Obrigatório.',
          value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || 'E-mail inválido';
        }
      ]
    };
  },
  methods: {
    validateField() {
      const valid = this.$refs.form.validate()

      if(this.pass === this.verif && this.pass != ""){
        this.appendIco = "mdi-check"
      } else {
        this.appendIco = ""
      }

      if (valid) {
        this.disabled = false
      } else {
        this.disabled = true
      }
    },
    registrar() {
      this.logging = true;
      this.disabled = true;
      const obj = {
        email: this.email,
        pass: this.pass
      }
      // this.$store.dispatch('setError', "")
      this.$store.dispatch('createUser', obj).then(res => {
        console.log(this.error, res)
      })
      if (this.error) {
        console.log(this.error)
        this.showAlert();
      }
    },
    showAlert() {
      this.logging = false;
      this.disabled = false;
      this.msg = "Alguma coisa deu errado! Verifique seus dados e sua conexão.";
      this.alert = true;
      this.$store.dispatch("setError", "")
    },
  },
};
</script>

<style>
  .append-icon {
    color: green;
  }
</style>